/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Drastic_Tech_Processing_AriaInputs */

const en_drastic_tech_processing_aria = /** @type {(inputs: Drastic_Tech_Processing_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Processing`)
};

const fr_drastic_tech_processing_aria = /** @type {(inputs: Drastic_Tech_Processing_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Traitement`)
};

const de_drastic_tech_processing_aria = /** @type {(inputs: Drastic_Tech_Processing_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verarbeitung`)
};

const it_drastic_tech_processing_aria = /** @type {(inputs: Drastic_Tech_Processing_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elaborazione`)
};

const ru_drastic_tech_processing_aria = /** @type {(inputs: Drastic_Tech_Processing_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обработка`)
};

const es_drastic_tech_processing_aria = /** @type {(inputs: Drastic_Tech_Processing_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tratamiento`)
};

const zh_cn2_drastic_tech_processing_aria = /** @type {(inputs: Drastic_Tech_Processing_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`加工`)
};

const ja_drastic_tech_processing_aria = /** @type {(inputs: Drastic_Tech_Processing_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`処理`)
};

const hi_drastic_tech_processing_aria = /** @type {(inputs: Drastic_Tech_Processing_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रसंस्करण`)
};

const pt_pt2_drastic_tech_processing_aria = /** @type {(inputs: Drastic_Tech_Processing_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Processamento`)
};

/**
* | output |
* | --- |
* | "Processing" |
*
* @param {Drastic_Tech_Processing_AriaInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const drastic_tech_processing_aria = /** @type {((inputs?: Drastic_Tech_Processing_AriaInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Drastic_Tech_Processing_AriaInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_drastic_tech_processing_aria(inputs)
	if (locale === "de") return de_drastic_tech_processing_aria(inputs)
	if (locale === "it") return it_drastic_tech_processing_aria(inputs)
	if (locale === "ru") return ru_drastic_tech_processing_aria(inputs)
	if (locale === "es") return es_drastic_tech_processing_aria(inputs)
	if (locale === "zh-CN") return zh_cn2_drastic_tech_processing_aria(inputs)
	if (locale === "ja") return ja_drastic_tech_processing_aria(inputs)
	if (locale === "hi") return hi_drastic_tech_processing_aria(inputs)
	if (locale === "pt-PT") return pt_pt2_drastic_tech_processing_aria(inputs)
	return en_drastic_tech_processing_aria(inputs)
});